import * as actionTypes from "../../../constants/actionTypes";
import { updateObject } from "../../../constants/utility";

const initialState = {
    provinces: null,
    cities: null,
    districts: null,
    subdistricts: null,     
};

const setProvinces = (state, data) => {
    return updateObject(state, {
        provinces: data,
    });
};

const setCities = (state, data) => {
    return updateObject(state, {
        cities: data,
    });
};

const setDistricts = (state, data) => {
    return updateObject(state, {
        districts: data,
    });
};

const setSubdistricts = (state, data) => {
    return updateObject(state, {
        subdistricts: data,
    });
};

const reducer = (state = initialState, action) => {
    const { data } = action;
    switch (action.type) {
        case actionTypes.FETCH_PROVINCES:
            return setProvinces(state, data);
        case actionTypes.FETCH_CITIES:
            return setCities(state, data);
        case actionTypes.FETCH_DISTRICTS:
            return setDistricts(state, data);
        case actionTypes.FETCH_SUBDISTRICTS:
            return setSubdistricts(state, data);
        default:
            return state;
    }
};

export default reducer;
